import styled from 'styled-components'

export const InputSelectContainer = styled.div`
  .input-select__control {
    min-width: 200px;
    cursor: pointer;
  }

  .input-select__menu {
    .input-select__menu-list {
      color: #000000;
      > .input-select__option--is-focused,
      > .input-select__option--is-selected {
        background: transparent;
        color: #610000;
      }
      .input-select__option {
        cursor: pointer !important;
      }
    }
  }
`

export const InputTextLabel = styled.label``

export const ErrorMsgContainer = styled.div``
